function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.543 11.874a31.273 31.273 0 009.623 2.08v2.406h4.811v-2.405c3.29-.206 6.531-.89 9.623-2.033v9.25H.543v-9.298zM16.18.724l1.203 1.203v2.405H24.6V10.6a34.125 34.125 0 01-11.523 2.153h-.866A33.786 33.786 0 01.543 10.54V4.332H7.76V1.927L8.963.724h7.217zM14.977 3.13h-4.811v1.202h4.811V3.13z",
  fill: "#fff"
});

function SvgIconProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    fill: "none"
  }, props), _ref);
}

export default SvgIconProjects;